import createModel from '../lib/create_model';

const FollowedTaskResponseReceived = createModel({
  modelName: 'FollowedTaskResponseReceived',

  properties: {
    itemId: String,
    customerId: String,
    taskId: String,
  },
});

export default FollowedTaskResponseReceived;
